import { Injectable } from "@angular/core";

import { Observable, take } from "rxjs";

import { HttpBaseService } from "../http/http-base.service";
import { Category } from "../../models/core/category.interface";
import { sharedEnvironment } from "../../../environments/shared-environment";

@Injectable({
  providedIn: "root"
})
export class CategoryService extends HttpBaseService {
  protected override getApiEndpoint(): string[] {
    return [sharedEnvironment.serviceUrl, "api", "content/category"];
  }

  public getCategoryFilterList(): Observable<Category[]> {
    return this.http.get<Category[]>(this.buildPath()).pipe(take(1));
  }
}
